import { SmileOutlined } from '@ant-design/icons';
import { Button } from 'antd';
const jsonNotification = (req, history, callback) => {
    let formJson = {
        message: 'Notification',
        description: req.data.name,
        duration: 0,
        icon: <SmileOutlined style={{ color: '#108ee9' }} />,
    }

    switch (req.type) {
        case "patient":
            var btn = (
                <Button type="primary" size="small" onClick={() => window.location = req.data.url}>
                    Accept
                </Button>
            );
            formJson = {
                ...formJson,
                message: 'Notification : ' + req.type,
                btn
            }
            callback(formJson)
            break;
        case "so-cart-marketing":
            var btn = (
                <Button type="primary" size="small" onClick={() => window.location = req.data.url}>
                    Answered
                </Button>
            );
            formJson = {
                ...formJson,
                message: 'ส่วนลดเกินกำหนด ต้องรอการอนุมัติ/ Overdue Discount Awaiting Approval :',
                btn
            }
            callback(formJson)
            break;
        case "cashier_discount_approve":
            var btn = (
                <Button type="primary" size="small" onClick={() => window.location = req.data.url}>
                    Answered
                </Button>
            );
            formJson = {
                ...formJson,
                message: 'ส่วนลดเกินกำหนด ต้องรอการอนุมัติ/ Overdue Discount Awaiting Approval :',
                btn
            }
            callback(formJson)
            break;
        default:
            callback(formJson)
            break;
    }
};
export default jsonNotification;